<script setup lang="ts">
    const series = [
        {
            name: "Souscriptions",
            data: [230, 250, 280, 320, 310, 290, 340, 360, 400] // Exemple
        }
    ];
    const chartOptions = {
        chart: { toolbar: { show: false } },
        colors: ["#3B82F6"],
        xaxis: {
            categories: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun", "Jul", "Aou", "Sep"]
        },
        plotOptions: {
            bar: {
            borderRadius: 5,
            columnWidth: "40%"
            }
        }
    };

    const repartitionProductsSeries = [45, 30, 10, 10, 5]; // Pourcentage
    const repartitionProductsChartOptions = {
        labels: ["Électroménagers", "Prêts", "Assurances", "Services", "Autres"],
        colors: ["#3B82F6", "#F59E0B", "#8B5CF6", "#10B981", "#94A3B8"],
        legend: { position: "bottom" }
    };

    const remboursementSeries = [
        {
            name: "Prévu",
            data: [20000, 24000, 26000, 28000, 30000, 32000]
        },
        {
            name: "Payé",
            data: [18000, 20000, 25000, 26000, 28000, 31000]
        }
    ];

    const remboursementChartOptions = {
        colors: ["#2563EB", "#10B981"],
        chart: { toolbar: { show: false } },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth" },
        fill: { opacity: 0.3 },
        xaxis: { categories: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun"] }
    };
</script>
<template>
    <section class="container-full-app bg-grey-50">
        <div class="page-space-5"></div>

        <div>
            <div class="container-full-2 my-5">
                <div class="s20">
                    <h4 class="font-semibold mt-4">
                        Dashboard Collectivités
                    </h4>
                </div>
            </div>
        </div>
        <div class="clear-both h-20"></div>

        <div class="d-flex">
            <section class="flex-1">
                <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
                    <!--Card-->
                    <div style="flex: 1;text-align: center;">
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-light">Total Collectivités</h4></div>
                            <div class="clear-both"></div>
                            <div class="text-4xl font-bold">128</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex-1">
                <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
                    <!--Card-->
                    <div style="flex: 1;text-align: center;">
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-light">Total Membres</h4></div>
                            <div class="clear-both"></div>
                            <div class="text-4xl font-bold">4 215</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex-1">
                <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
                    <!--Card-->
                    <div style="flex: 1;text-align: center;">
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-light">Encours total</h4></div>
                            <div class="clear-both"></div>
                            <div class="text-4xl font-bold">183 400  000</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex-1">
                <div class="widget shadow-100" style="height: 90px;display: flex;justify-content: center;align-items: center;">
                    <!--Card-->
                    <div style="flex: 1;text-align: center;">
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-light">Retards paiement</h4></div>
                            <div class="clear-both"></div>
                            <div class="text-4xl font-bold">57</div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="clear-both h-20"></div>

        <div class="d-flex" style="height: 400px">
            <section style="height: 100%;display: flex; flex: 1 1 60%">
                <div class="widget shadow-100 pb-2">
                    <!--Card-->
                    <div>
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-semibold mt-8">Souscriptions par mois</h4></div>
                            <div class="clear-both h-20"></div>
                            <apexchart type="bar" height="300" :options="chartOptions" :series="series" />
                        </div>
                    </div>
                </div>
            </section>
            <!-- <section class="flex-1" style="height: 100%;display: flex;">
                <div class="widget shadow-100 pb-2">
                    <div>
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-semibold mt-8">Répartition des produits</h4></div>
                            <div class="clear-both h-20"></div>
                            <apexchart type="donut" height="300" :options="repartitionProductsChartOptions" :series="repartitionProductsSeries" />
                        </div>
                    </div>
                </div>
            </section> -->
            <section class="flex-1" style="height: 100%;display: flex;">
                <div class="widget shadow-100 pb-2">
                    <!--Card-->
                    <div>
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-semibold mt-8">Collectivités les plus actives</h4></div>
                            <div class="clear-both h-20"></div>
                            <div class="clear-both"></div>
                            <table class="table separator skin1">
                                <thead>
                                    <tr> 
                                        <th>Nom</th>
                                        <th><img src="/icons/icon-filter-down.svg" class="size-xxs mt--1" alt="" /> Membres</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Collectivité A</td>
                                        <td>450</td>
                                    </tr>
                                    <tr>
                                        <td>Collectivité B</td>
                                        <td>380</td>
                                    </tr>
                                    <tr>
                                        <td>Collectivité C</td>
                                        <td>320</td>
                                    </tr>
                                    <tr>
                                        <td>Collectivité D</td>
                                        <td>290</td>
                                    </tr>
                                    <tr>
                                        <td>Collectivité E</td>
                                        <td>250</td>
                                    </tr>
                                    <tr>
                                        <td>Collectivité F</td>
                                        <td>220</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="clear-both h-20"></div>

        <div class="d-flex" style="height: 400px">
            <section class="flex-1" style="height: 100%;display: flex;">
                <div class="widget shadow-100 pb-2">
                    <!--Card-->
                    <div>
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-semibold mt-8">Courbe des remboursements (Prévu vs Payé)</h4></div>
                            <div class="clear-both"></div>
                            <apexchart type="area" height="300" :options="remboursementChartOptions" :series="remboursementSeries"  />
                        </div>
                    </div>
                </div>
                
            </section>
            <section class="flex-1" style="height: 100%;display: flex;">
                <div class="widget shadow-100 pb-2">
                    <!--Card-->
                    <div>
                        <div class="container-full-2">
                            <div class="s20"><h4 class="font-semibold mt-8">Membres avec retards de paiement</h4></div>
                            <div class="clear-both"></div>
                            <table class="table separator skin1">
                                <thead>
                                    <tr> 
                                        <th>Nom &amp; Prénoms</th>
                                        <th>Collectivité</th>
                                        <th>Solde</th>
                                        <th><img src="/icons/icon-filter-down.svg" class="size-xxs mt--1" alt="" /> Date Dernier Paiement</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Jean Dupont</td>
                                        <td>Collectivité A</td>
                                        <td>120 000</td>
                                        <td>15 Mai 2024</td>
                                    </tr>
                                    <tr>
                                        <td>Marie Curie</td>
                                        <td>Collectivité B</td>
                                        <td>95 000</td>
                                        <td>10 Mai 2024</td>
                                    </tr>
                                    <tr>
                                        <td>Paul Martin</td>
                                        <td>Collectivité C</td>
                                        <td>80 000</td>
                                        <td>05 Mai 2024</td>
                                    </tr>
                                    <tr>
                                        <td>Sophie Bernard</td>
                                        <td>Collectivité D</td>
                                        <td>75 000</td>
                                        <td>01 Mai 2024</td>
                                    </tr>
                                    <tr>
                                        <td>Lucie Dubois</td>
                                        <td>Collectivité E</td>
                                        <td>60 000</td>
                                        <td>28 Avr 2024</td>
                                    </tr>
                                    <tr>
                                        <td>Marc Lefevre</td>
                                        <td>Collectivité F</td>
                                        <td> fifty thousand</td>
                                        <td>25 Avr 2024</td>
                                    </tr>
                                    <tr>
                                        <td>Emma Moreau</td>
                                        <td>Collectivité G</td>
                                        <td>45 000</td>
                                        <td>20 Avr 2024</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="clear-both h-20"></div>
    </section>
</template>